import {Box, Button, Dialog, DialogActions, DialogContent, Tab} from "@mui/material";
import BaseDialogTitle from "./BaseDialogTitle";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import {SyntheticEvent, useState} from "react";
import NewFileDropzoneForm from "../forms/NewFileDropzoneForm";
import LibraryFilesSelectForm from "../forms/LibraryFilesSelectForm";
import {FileBase} from "../../types/solicitation/solicitationFile";


interface NewFileDialogProps {
    open: boolean,
    onClose: () => void,
    clientId: number,
    onNewFile?: (fileBase?: FileBase, file?: File, fileId?: number) => Promise<number>,
    fileType?: number,
    onReload?: () => void
}


const NewFileDialog = ({open, onClose, clientId, onNewFile, fileType, onReload}: NewFileDialogProps) => {
    const [currentTab, setCurrentTab] = useState<string>("0");
    
    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setCurrentTab(newValue);
    }
    
    return (
        <Dialog open={open}
                onClose={onClose}
                maxWidth={'md'}
                fullWidth
        >
            <BaseDialogTitle onClose={onClose} title={'Adjuntar archivo'} />
            <DialogContent>
                    <Box sx={{width: '100%', typography: 'body1'}}>
                        <TabContext value={currentTab}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example"
                                     variant='fullWidth'
                            >
                                <Tab label="Subir nuevo archivo" value="0"/>
                                <Tab label="Relacionar desde biblioteca" value="1"/>
                            </TabList>
                            <TabPanel value="0">
                                <NewFileDropzoneForm onSubmitFile={onNewFile} fileType={fileType} onClose={onClose} onReload={onReload}/>
                            </TabPanel>
                            <TabPanel value="1">
                                <LibraryFilesSelectForm onSubmitFile={onNewFile} clientId={clientId} onClose={onClose} onReload={onReload}/>
                            </TabPanel>
                        </TabContext>
                    </Box>
            </DialogContent>
            <DialogActions>
                <Button color={'primary'} variant={'contained'} type={'submit'} 
                        form={`${currentTab === "0" ? 'newFile-form-dropzone'
                    : currentTab === "1" ? 'file-from-library-form'
                        : ''}`}>
                    Adjuntar
                </Button>
            </DialogActions>
        </Dialog>
    )
}


export default NewFileDialog